// extracted by mini-css-extract-plugin
export var md = "_2t-4";
export var semantic = "_2t-5";
export var sm = "_2t-3";
export var text = "_2t-6";
export var toggleInput = "_2t-0";
export var toggleSwitch = "_2t-1";
export var xs = "_2t-2";